<template>
  <div>
    <a
      href="#"
      class="btn btn-light-facebook btn-sm px-4 custom-btn text-no-wrap"
      @click="toggleModal"
      >{{ buttonText }}</a
    >
    <div>
      <v-dialog
        v-model="dialog"
        persistent
        transition="dialog-bottom-transition"
        fullscreen
      >
        <!--begin::Modal dialog-->
        <div class="bg-white poppins min-h-100">
          <!--begin::Modal header-->
          <div class="modal-header py-4 align-center">
            <h4 class="mb-0 font-weight-bolder">History</h4>
            <!--begin::Close-->
            <div
              class="btn btn-sm btn-icon btn-active-light-info"
              @click="dialog = false"
            >
              <span class="svg-icon">
                <v-icon size="22">mdi-close</v-icon>
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--begin::Modal header-->
          <!--begin::Modal body-->
          <div
            v-if="serverData"
            class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7"
          >
            <!--begin::Body-->
            <div class="row ma-0">
              <div class="col-12 col-md-6">
                <div class="pa-0 w-100" v-if="history?.before.query">
                  <RuleBuilder
                    :query="history.before.query"
                    :options="serverData?.operands"
                    :operators="serverData?.operators"
                    :userId="userId"
                    typeLabel="Rule before"
                  />
                </div>
                <div class="mt-4 pa-0 w-100" v-if="history?.before.attributes">
                  <ActionBuilder
                    :query="history.before.attributes"
                    :options="serverData.attributes"
                    :operators="serverData"
                    :userId="userId"
                    typeLabel="Action before"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="pa-0 w-100" v-if="history?.after.query">
                  <!--              :style="{ height: targetHeight }"-->
                  <RuleBuilder
                    :query="history.after.query"
                    :options="serverData?.operands"
                    :operators="serverData?.operators"
                    :userId="userId"
                    typeLabel="Rule after"
                  />
                </div>
                <div class="mt-4 pa-0 w-100" v-if="history?.after.attributes">
                  <ActionBuilder
                    :query="history.after.attributes"
                    :options="serverData.attributes"
                    :operators="serverData"
                    :userId="userId"
                    typeLabel="Action after"
                  />
                </div>
              </div>
            </div>
            <!--end::Body-->
          </div>
          <!--end::Modal body-->
        </div>
        <!--end::Modal dialog-->
      </v-dialog>
    </div>
  </div>
</template>

<script>
import RuleBuilder from "@/own/components/orderManagement/rules/ruleBuilder/RuleBuilder";
import ActionBuilder from "@/own/components/orderManagement/rules/actionBuilder/ActionBuilder";
export default {
  name: "HistoryRow",
  props: ["history", "isDataAvailable", "serverData", "userId"],
  components: { RuleBuilder, ActionBuilder },
  data: () => ({
    dialog: false,
  }),
  computed: {
    buttonText: function () {
      let text = "View";
      if (!this.isDataAvailable) text = "No data";
      return text;
    },
  },
  methods: {
    toggleModal() {
      if (this.buttonText !== "No data") this.dialog = !this.dialog;
    },
  },
};
</script>
